
import React, { useRef } from "react";
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import Nav from './Nav'


const Header = () => {
  const targetElement = useRef(null);
  const handleClick = (target) => {
    // alert(target)
    // alert(true)
    const targetElement = document.getElementById(target);
    targetElement.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <MainHeader className="main-header">
      <div className='left-header'>
      <NavLink to={'/'} >
            <div className='img-container'>
            <img src="../react_logo.png" alt="Logo" height="24" /> 
            </div>
     
        </NavLink>
        <NavLink to={'/'} className='nav-bar-link'>
            <div onClick={()=>  window.scrollTo(0, 0)} > Profile</div>
        </NavLink>
     
        <NavLink to={'/'} className='nav-bar-link'>
            <div onClick={()=>handleClick('exp-target')} > Experience</div>
        </NavLink>
        <NavLink to={'/'} className='nav-bar-link'>
            <div onClick={()=>handleClick('education-target')} > Education</div>
        </NavLink>
        <NavLink to={'/'} className='nav-bar-link'>
            <div onClick={()=>handleClick('skills-target')} > Skills</div>
        </NavLink>
        <NavLink to={'/'} className='nav-bar-link'>
            <div onClick={()=>handleClick('project-target')} > Projects</div>
        </NavLink>
        <NavLink to={'/'} className='nav-bar-link'>
            <div onClick={()=>handleClick('courses-target')} > Courses</div>
        </NavLink>
        <NavLink to={'/'} className='nav-bar-link'>
            <div onClick={()=>handleClick('contact-target')} > Contact</div>
        </NavLink>
      </div>
      
        {/* <Nav/> */}
        {/* <h1>header two</h1> */}
    </MainHeader>

  )
}

const MainHeader = styled.header`
position: sticky;
top: 0;
left: 0;
right: 0;
display: flex;
z-index: 999;
/* padding-left: 4rem;
padding-right: 4rem; */
/* background-color:#ede9e8; */
/* background-color:#056BA6; */
background-color: #FF3CAC;
background-image: linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%);

justify-content: space-between;
align-items: center;
.img-container{
    align-items: center;
    text-decoration: none;
    list-style-type:none;
    justify-content: center;
    margin: 0.4rem;
    margin-left: 4rem;
}
.left-header{
  display: flex;
  align-items: center;
  /* gap: 1rem; */
}
.nav-bar-link{
        font-size: small;
        color: white;
        text-decoration: none;
        align-items: center;
        justify-content: center;
        margin-left: 2rem;


    }
    @media (max-width: 450px) {
.left-header{
    display: none;
}
.main-header{
  display: none;
}


}
`

export default Header